module.exports = __webpack_public_path__ + "169ac9bd6b8a00f97c6719726faf3690.pdf";